import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PurchaseFlowComponent } from 'src/app/shared/cinejoy/common/purchase-flow/purchase-flow.component';
import * as moment from 'moment-timezone';
import { MatDialog } from '@angular/material/dialog';
import { CreateGroupPopupComponent } from 'src/app/features/group-sharing/create-group-popup/create-group-popup.component';
import { environment } from 'src/environments/environment';
import { MyTicketCinejoy } from 'src/app/shared/cinejoy/spotlight/models/my-ticket-cinejoy/my-ticket-cinejoy.model';
import { MyTicketScreeningParties } from 'src/app/shared/cinejoy/spotlight/models/my-ticket-screening-parties/my-ticket-screening-parties.model';
import { AgileIntegrationService } from 'src/app/core/services/agile/agile-integration.service';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import {GroupSharingService, WatchPartyType} from 'src/app/features/group-sharing/group-sharing.service.component';
import {EditGroupPopupComponent} from "../../../group-sharing/edit-group-popup/edit-group-popup.component";
import {InvitationSource, WatchPartyRequestFlow} from "../../../../core/models/common.models";
import {UserInvitationService} from "../../../../core/services/user.invitation.service";

@Component({
  selector: 'app-premiere-description',
  templateUrl: './premiere-description.component.html',
  styleUrls: ['./premiere-description.component.css']
})
export class PremiereDescriptionComponent implements OnInit, OnChanges {
  @Input() premiereDetails: any;
  @Input() tags: any;
  joinButtonDisabled = true;
  timezone: any;
  groupshareUrl:any;
  exsistingGroup:boolean = false;
  eventDetails:any;
  spotlightsTickets: any = new Array();
  showcaseTickets: MyTicketCinejoy[] = new Array();
  screeningPartiesTickets: MyTicketScreeningParties[] = new Array();
  isBuyButtonActive:boolean=false;
  constructor(private router: Router,
    private modalService: NgbModal,
    public dialog: MatDialog,
    private agileIntegration: AgileIntegrationService,
    private authService: AuthenticationService,
    private groupsharingService: GroupSharingService,
    private readonly userInvitationService: UserInvitationService) { }

  ngOnInit(): void {
    this.joinButtonEnable();
    this.authService.checkUserAuthenticated().subscribe((res)=>{
      if(res.userId > 0){
        this.fetchTickets()
        this.getActiveParties()
      }
    }, err=>{

    })
    var zone = moment.tz.guess();
    this.timezone = moment(this.premiereDetails.cinejoySpotlightsSchedule[0].scheduleTimeText).tz(zone).zoneName();
    this.groupshareUrl = `/cinejoy/group-share-info-page`
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.premiereDetails) {
      this.joinButtonEnable();
    }
  }

  joinButtonEnable(): void {
    if (this.premiereDetails !== undefined) {
      let currentTimeText = Date.now();
      this.premiereDetails.cinejoySpotlightsSchedule = this.premiereDetails.cinejoySpotlightsSchedule.sort((x: any, y: any) => +new Date(x.scheduleTimeText) - +new Date(y.scheduleTimeText));
      const endOfFestivitiesAdd10 = this.premiereDetails.cinejoySpotlightsSchedule[this.premiereDetails.cinejoySpotlightsSchedule.length - 1].scheduleTimeText + (10 * 60 * 60 * 1000);
      setInterval(() => {
        currentTimeText = Date.now();
        if ((this.premiereDetails.cinejoySpotlightsSchedule[0].scheduleTimeText <= currentTimeText) && (endOfFestivitiesAdd10 >= currentTimeText)) {
          this.joinButtonDisabled = false;
        } else if (this.premiereDetails.cinejoySpotlightsSchedule[0].scheduleTimeText > currentTimeText) {
          this.joinButtonDisabled = true;
        } else {
          this.joinButtonDisabled = true;
        }
      }, 1000);
    }
  }

  redirect(): void {

    let userAgent = navigator.userAgent;
    let browserName;
    if (userAgent.match(/firefox|fxios/i)) {
      browserName = "Firefox";
      alert("Hi,\nFor a better experience please use Google Chrome, Safari or Microsoft Edge.\n\nThank you!")
    }

    const currentTimeText = Date.now();
    const redCarpetSchedule = this.premiereDetails.cinejoySpotlightsSchedule.filter((x: any) => x.scheduleMainText === 'Red Carpet');
    const theaterURL = 'cinejoy/premiere/theater/' + this.premiereDetails.eventId; // + '/' + this.premiere.name.replaceAll(' ', '-');
    const redCarpetURL = 'cinejoy/premiere/redcarpet/' + this.premiereDetails.eventId + '/' + this.premiereDetails.name.replaceAll(' ', '-');
    const groupSharingSchedule = this.premiereDetails.cinejoySpotlightsSchedule.find((x: any) => x.scheduleMainText === 'GS1')
    const groupSharingScheduleQA = this.premiereDetails.cinejoySpotlightsSchedule.filter((x: any) => x.scheduleMainText === 'GS2');
    if (redCarpetSchedule === undefined || redCarpetSchedule === null) {

      this.router.navigate([theaterURL]);
    } else {
      if ((groupSharingSchedule.scheduleTimeText <= currentTimeText) && (currentTimeText <= redCarpetSchedule[0].scheduleTimeText)) {
        this.router.navigate(['cinejoy/spotlight-root/' + this.premiereDetails.eventId + '/' + this.premiereDetails.name.replaceAll(' ', '-')])
      //  this.router.navigate(['cinejoy/group-sharing/lobby/' + this.premiereDetails.eventId])
      } else if ((redCarpetSchedule[0].scheduleTimeText <= currentTimeText) && (this.premiereDetails.cinejoySpotlightsSchedule[this.getRedCarpetIndex() + 1].scheduleTimeText >= currentTimeText)) {
        this.router.navigate(['cinejoy/spotlight-root/' + this.premiereDetails.eventId + '/' + this.premiereDetails.name.replaceAll(' ', '-')])
        //this.router.navigate([redCarpetURL]);
      } else if (groupSharingScheduleQA[0].scheduleTimeText <= currentTimeText) {
        this.router.navigate(['cinejoy/spotlight-root/' + this.premiereDetails.eventId + '/' + this.premiereDetails.name.replaceAll(' ', '-')])
       // this.router.navigate(['cinejoy/group-sharing/qa-lobby/' + this.premiereDetails.eventId])
      } else {
        this.router.navigate(['cinejoy/spotlight-root/' + this.premiereDetails.eventId + '/' + this.premiereDetails.name.replaceAll(' ', '-')])
      //  this.router.navigate([theaterURL]);
      }
    }
  }

  getRedCarpetIndex(): number {
    let i = 0;
    for (const schedule of this.premiereDetails.cinejoySpotlightsSchedule) {
      if (schedule.scheduleMainText === 'Red Carpet') {
        break;
      }
      i++;
    }
    return i;
  }

  open(eventId: number, premiere: any, purchaseStage: string): void {
    const modalRef = this.modalService.open(PurchaseFlowComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.eventId = eventId;
    modalRef.componentInstance.premiere = premiere;
    modalRef.componentInstance.purchaseStage = purchaseStage;
    modalRef.result.then(
			(result) => {

        this.fetchTickets()
			},
			(reason) => {

			},
		);
  }

  openDialog(event) {
    if (this.exsistingGroup) {
      this.dialog.open(EditGroupPopupComponent, {
        panelClass: 'pre-schedule-modalbox',
        width: '600px',
        height: '70%',
        data: {
          eventId: event.eventId,
          isPreScheduleEvent: true,
          isEventStarted: this.joinButtonDisabled
        }
      }).afterClosed().subscribe((res) => {
        console.log('===== dialog closed with response: ', res);
        this.getActiveParties();
        if (res && res.invitedEmails) {
          this.inviteUser(res);
        }
      });
    } else {
      this.dialog.open(CreateGroupPopupComponent, {
        panelClass: 'pre-schedule-modalbox',
        width: '600px',
        height: '65%',
        data: {
          eventId: event.eventId,
          isPreScheduleEvent: true
        },
      }).afterClosed().subscribe((res) => {

        // if (res) {
        this.getActiveParties()
        //  }

      })
    }
  }


  fetchTickets(): void {
    //this.isLoading = true;
    this.agileIntegration.fetchTickets().subscribe(
      (response) => {
        // this.isLoading = false;
        const tickets = response.agiletixEvents ? response.agiletixEvents : [];

        this.spotlightsTickets = tickets.filter(
          (ticket) =>
            ticket.type !== undefined &&
            ticket.type !== null &&
            ticket.type.toLowerCase().includes('spotlight')
        );
        this.spotlightsTickets = this.spotlightsTickets.sort(
          (a, b) =>
            new Date(a.StartDateTime).getTime() -
            new Date(b.StartDateTime).getTime()
        );

        if(this.spotlightsTickets.find((v)=> (v.AccessStatus ==='AccessValid' || v.AccessStatus ==='BeforeEvent') && v.ParentID ==  this.premiereDetails.eventId)){
          this.isBuyButtonActive = true;
        }


      },
      (error) => {
        //this.isLoading = false;

      }
    );
  }

  getActiveParties() {
    this.groupsharingService.getActiveWatchParty(this.premiereDetails.eventId).subscribe((res) => {
      let item: any = '';
      if (localStorage.getItem('userData')) {
        item = JSON.parse(localStorage.getItem('userData'))
      }
      item['userId'] = item.userID ? item.userID : item.userId
      if (res.filter((v) => v.userId == item.userId).length > 0) {
        this.eventDetails = res.find((v) => v.userId == item.userId);
        this.exsistingGroup = true;
      } else {
        this.exsistingGroup = false;
      }
    }, err => {

    })
  }

  inviteUser(dialogResponse: any) {
    if (!dialogResponse.invitedEmails || !dialogResponse.invitedEmails.length) {
      return;
    }

    for (const email of dialogResponse.invitedEmails) {
      const invitationRequest = {
        emailAddress: email,
        invitedUserName: "Invited User",
        invitationSource: InvitationSource.WATCH_PARTY,
        invitationSourceMetadata: {
          watchPartyRequestFlow: WatchPartyRequestFlow.NEW_PARTICIPANT_ADDED,
          watchPartyParticipantRequest: {
            partyType: WatchPartyType.PRIVATE,
            customRoomId: dialogResponse.customRoomId,
            eventId: dialogResponse.eventId,
            userIds: []
          }
        }
      }

      this.userInvitationService.inviteNewUser(invitationRequest)
        .then(() => {
          console.log(`user: ${email} invited successfully`);
        });
    }
  }
}
